/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import {} from 'carbon-addons-iot-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Section.module.css';
import {} from './svg/kc.svg';

const propTypes = {
  title: PropTypes.string.isRequired,
  primaryAction: PropTypes.node.isRequired,
  secondaryAction: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

const Section = ({ title, primaryAction, secondaryAction, children }) => (
  <section className={styles.container}>
    <div className={styles.layoutWidth}>
      <div className={styles.containerHeading}>
        <h2 className={styles.heading}>{title}</h2>
      </div>
      <div className={styles.containerItem}>
        <p className={styles.bodyText}>{children}</p>
        {primaryAction}
        {secondaryAction}
      </div>
    </div>
  </section>
);

Section.propTypes = propTypes;

export default Section;
